// src/App.js
import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./screens/sidebar";
import AddUsers from "./screens/add-users";
import Inventory from "./screens/inventory";
import Invoices from "./screens/invoices";
import LoginScreen from "./screens/login";
import { AuthContext } from "./auth-context"; // Ensure the path is correct
import Dashboard from "./screens/dashboard";
import ManageUsers from "./screens/manage-users";
import InventoryAnalytics from "./screens/InventoryAnalytics";
import ConsolidatedInvoiceScreen from "./screens/ConsolidatedInvoiceScreen";
import "@fontsource/roboto";
import { createTheme, ThemeProvider, useMediaQuery } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import muiTheme from "./theme/muiTheme";
import EnhancedWasteManagementTab from "./screens/EnhancedWasteManagementTab";
import CutoffNotificationsSettings from "./screens/CutoffNotificationsSettings";
import TodayInvoicesGrid from "./components/TodayInvoicesGrid";

const App = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <ThemeProvider theme={muiTheme}>
       <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CssBaseline />
      <Router>
        <Routes>
          {isAuthenticated ? (
            <Route
              path="*"
              element={
                <div style={{ display: "flex" }}>
                  <Sidebar />
                  <main style={{ width:isMobile ? '100%' : '82%' }}>
                    <Routes>
                      <Route
                        path="/waste-management"
                        element={<EnhancedWasteManagementTab />}
                      />
                      <Route path="/add-users" element={<AddUsers />} />
                      <Route path="/inventory" element={<Inventory />} />
                      <Route path="/invoices" element={<Invoices />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/manage-users" element={<ManageUsers />} />
                      <Route path="/inventory-analytics" element={<InventoryAnalytics />} />
                      <Route
                        path="/ConsolidatedInvoiceScreen"
                        element={<ConsolidatedInvoiceScreen />}
                      />
                      <Route path="/cutoff-notifications" element={<CutoffNotificationsSettings />} />
                      <Route path="/order-dashboard" element={<TodayInvoicesGrid />} />
                      
                      {/* Add more routes as needed */}
                    </Routes>
                  </main>
                </div>
              }
            />
          ) : (
            <Route path="/" element={<LoginScreen />} />
          )}
        </Routes>
      </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
